import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { SiteProvider } from "./context/SiteContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import LeadershipPage from "./pages/LeadershipPage";
import ServicesPage from "./pages/ServicesPage";
import ProjectsPage from "./pages/ProjectsPage";
import ClientsPage from "./pages/ClientsPage";
import CareersPage from "./pages/CareersPage";
import ContactPage from "./pages/ContactPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";

function ProtectedRoute({ children }) {
  const { token, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050A0F] text-[#94A3B8]">
        Loading...
      </div>
    );
  }
  if (!token) return <Navigate to="/admin/login" replace />;
  return children;
}

function PublicLayout({ children }) {
  return (
    <div className="min-h-screen bg-[#050A0F] text-[#F8FAFC] flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

function ScrollToTop() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}

function App() {
  return (
    <AuthProvider>
      <SiteProvider>
        <BrowserRouter>
          <Toaster position="top-right" theme="dark" richColors />
          <Routes>
            <Route path="/" element={<PublicLayout><ScrollToTop /><HomePage /></PublicLayout>} />
            <Route path="/about" element={<PublicLayout><ScrollToTop /><AboutPage /></PublicLayout>} />
            <Route path="/leadership" element={<PublicLayout><ScrollToTop /><LeadershipPage /></PublicLayout>} />
            <Route path="/services" element={<PublicLayout><ScrollToTop /><ServicesPage /></PublicLayout>} />
            <Route path="/projects" element={<PublicLayout><ScrollToTop /><ProjectsPage /></PublicLayout>} />
            <Route path="/clients" element={<PublicLayout><ScrollToTop /><ClientsPage /></PublicLayout>} />
            <Route path="/careers" element={<PublicLayout><ScrollToTop /><CareersPage /></PublicLayout>} />
            <Route path="/contact" element={<PublicLayout><ScrollToTop /><ContactPage /></PublicLayout>} />
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboardPage />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </SiteProvider>
    </AuthProvider>
  );
}

export default App;
